import React, {useEffect} from 'react';
import {useConfig} from "../context/ConfigProvider";
import {Keys} from "../config/AppConfig";

const TestPage = ({}) => {
    const TAG = "TestPage";
    const {updateConfig} = useConfig();

    useEffect(() => {

        updateConfig(Keys.tracker_currPageModule, TAG);
        updateConfig(Keys.tracker_currPageTag, TAG);
    }, []);

    return (<>
            <div
                className={` `}
            >
                {TAG}
            </div>
        </>
    )

    function fun() {

    }
}
export default TestPage;
